import './motion_mui.css';
import React from "react";
import {motion} from "framer-motion";
import {Grid, Paper} from "@material-ui/core";


interface FullSizedWindowProps {
    visible?: boolean,
    centerVertically?: boolean,
    centerHorizontally?: boolean,
    style?: React.CSSProperties,
    onTap?: (event: MouseEvent | TouchEvent | PointerEvent) => void
}

export const FullSizedWindow = React.forwardRef<HTMLDivElement, React.PropsWithChildren<FullSizedWindowProps>>(
    (props, ref) => {
        const {visible, centerVertically, centerHorizontally, style, onTap, ...otherProps} = props;
        const fullSizedWindowStyle = {
            position: 'fixed',
            top: '0',
            left: '0',
            height: '100vh',
            width: '100vw',
            display: 'flex',
            justifyContent: centerHorizontally ? 'center' : 'start',
            alignItems: centerVertically ? 'center' : 'start',
            visibility: visible ? 'visible' : 'hidden',
            ...style,
        } as React.CSSProperties;

        return <motion.div ref={ref} style={fullSizedWindowStyle} {...otherProps}>
            {props.children}
        </motion.div>
    })

export const FullSizedWindowMotion = motion(FullSizedWindow);


interface CenterProps{
    style?: React.CSSProperties
}

export const Center = React.forwardRef<HTMLDivElement, React.PropsWithChildren<CenterProps>>(
    (props, ref) => {
        const centerStyle = {
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            ...props.style
        } as React.CSSProperties;

        return <motion.div ref={ref} style={centerStyle}>
            {props.children}
        </motion.div>
    });

export const CenterMotion = motion(Center);

type mainAxisAlignment = "center" | "stretch" | "start" | "end" | "spaceAround" | "spaceBetween" | "spaceEvenly";
type crossAxisAlignment = "center" | "stretch" | "start" | "end" | "baseline"

function crossAxisAlignmentToAlignItems(crossAxisAlignment: crossAxisAlignment) {
    switch (crossAxisAlignment) {
        case "center":
            return "center";
        case "start":
            return "flex-start";
        case "end":
            return "flex-end";
        case "stretch":
            return "stretch";
        case "baseline":
            return "baseline"
        default:
            return "flex-start";
    }
}

function mainAxisAlignmentToJustifyContent(mainAxisAlignment: mainAxisAlignment) {
    switch (mainAxisAlignment) {
        case "center":
            return "center";
        case "start":
            return "flex-start";
        case "end":
            return "flex-end";
        case "stretch":
            return "stretch";
        case "spaceAround":
            return "space-around";
        case "spaceBetween":
            return "space-between";
        case "spaceEvenly":
            return "space-evenly";
        default:
            return "flex-start";
    }
}

interface ColumnProps {
    mainAxisAlignment: mainAxisAlignment,
    crossAxisAlignment: crossAxisAlignment,
    style?: React.CSSProperties,
    className?: string,
}

export const Column = React.forwardRef<HTMLDivElement, React.PropsWithChildren<ColumnProps>>(
    (props, ref) => {

        const columnStyle = {
            display: "flex",
            flexDirection: "column",
            alignItems: crossAxisAlignmentToAlignItems(props.crossAxisAlignment),
            justifyContent: mainAxisAlignmentToJustifyContent(props.mainAxisAlignment),
            ...props.style
        } as React.CSSProperties;

        return <div className={props.className} ref={ref} style={columnStyle}>
            {props.children}
        </div>
    });

export const ColumnMotion = motion(Column);

interface RowProps {
    mainAxisAlignment: mainAxisAlignment,
    crossAxisAlignment: crossAxisAlignment,
    style?: React.CSSProperties,
    className?: string,
}

export const Row = React.forwardRef<HTMLDivElement, React.PropsWithChildren<RowProps>>(
    (props, ref) => {

        const rowStyle = {
            display: "flex",
            flexDirection: "row",
            alignItems: crossAxisAlignmentToAlignItems(props.crossAxisAlignment),
            justifyContent: mainAxisAlignmentToJustifyContent(props.mainAxisAlignment),
            ...props.style
        } as React.CSSProperties;

        return <div className={props.className} ref={ref} style={rowStyle}>
            {props.children}
        </div>
    });

export const RowMotion = motion(Row);

// TODO Smart column with smart loading and load animation

interface ListViewBuilder {
    (index: number): React.Component;
}

interface ListViewProps {
    style?: React.CSSProperties,
    itemCount?: number,
    itemBuilder?: ListViewBuilder
}

export const ListView = React.forwardRef<HTMLDivElement, React.PropsWithChildren<ListViewProps>>(
    (props, ref) => {

        // TODO use builder
        const {style, ...restProps} = props;

        const listViewStyle = {
            flexGrow: 1,
            ...style
        } as React.CSSProperties;

        return <Column ref={ref} mainAxisAlignment={"start"} crossAxisAlignment={"stretch"} style={listViewStyle} {...restProps}>
            {props.children}
        </Column>
    });

export const ListViewMotion = motion(ListView);

export const PaperMotion = motion(Paper);

export const GridMotion = motion(Grid);


// TODO MUI Grid








